// extracted by mini-css-extract-plugin
export default {"webPromotionPage":"style_webPromotionPage__4wTFi","promotionBlock":"style_promotionBlock__LK+Vm"};